import * as React from 'react'
import { Modal, Button, Typography, Input, InputNumber } from 'antd'
import { IDevice } from '@getgreenline/homi-shared'
import { HelpLinks } from '../../../../constants/ExternalLinks'

interface Props {
  device: IDevice
  onHide: () => void
}

export const MonerisConfigurationModal = (props: Props) => {
  const { terminalPort, terminalIpAddress } = props.device

  return (
    <Modal
      title='Configure Moneris terminal'
      visible={true}
      onCancel={props.onHide}
      footer={[
        <Button key='cancel' onClick={props.onHide}>
          Cancel
        </Button>,
      ]}
    >
      <div>
        <Typography.Text type='secondary'>
          Setup instructions can be found{' '}
          <a href={HelpLinks.MONERIS_TERMINAL_SETUP} target='_blank' rel='noreferrer'>
            here
          </a>
          .
        </Typography.Text>
      </div>
      <br />
      <div>
        <label>Terminal port</label>
        <InputNumber style={{ width: '100%' }} value={terminalPort || undefined} disabled />
      </div>
      <div>
        <label>Terminal IP Address</label>
        <Input style={{ width: '100%' }} value={terminalIpAddress || undefined} disabled />
      </div>
    </Modal>
  )
}
